module.exports = __webpack_public_path__ + "img/quotation.0d322dda.png";